import { render } from "./ProgramCard.vue?vue&type=template&id=7d2bb21a&scoped=true&ts=true"
import script from "./ProgramCard.vue?vue&type=script&lang=ts"
export * from "./ProgramCard.vue?vue&type=script&lang=ts"

import "./ProgramCard.vue?vue&type=style&index=0&id=7d2bb21a&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2bb21a"]])

export default __exports__